export default __webpack_public_path__ + "static/media/noTask.e249a683.png";